import ApiFetcher3 from '../ApiFetcher3';

class TeachingFrameworkApi {
  static getSkillsByFramework(params) {
    return ApiFetcher3.get('teaching-framework/', params);
  }
}

export default TeachingFrameworkApi;
